/* eslint-disable no-unused-vars */

import IconAlert from 'components/common/IconAlert';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import { Spinner } from 'react-bootstrap';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)

import { toast } from 'react-toastify';
import { sdGenerateAttachmentDownloadURL } from 'services/service-desk/sdService';

export const SD_PRIORITY_COLOUR_MAP = {
    1: '#5993eb',
    2: '#59d3eb',
    3: '#ebb159',
    4: '#eb8259',
    5: '#eb7159',
}

export const SD_STATUS_COLOUR_MAP = {
    Open: '#ced7de',
    InProgress: '#44a0eb',
    Done: '#71eb59'
}
export const sdGetStatusColour = (key) => SD_STATUS_COLOUR_MAP[key] || '#000000'; // default to black

export const sdGetPriorityColour = (priorityValue) => SD_PRIORITY_COLOUR_MAP[priorityValue] || SD_PRIORITY_COLOUR_MAP[0];

// Fetch Helper
export function sdCreateRequest(request, setter) {
    return request().then(res => {
        setter(res.data);
    });
}

export const sdMakeRequests = async (requests, loadingSetter, errorSetter) => {
    await Promise.all(requests)
        .then(res => {
            loadingSetter(false)
            errorSetter(null);
        })
        .catch(err => {
            errorSetter(err);
        }).finally(() => {
            loadingSetter(false);
        });
}

export function sdRequestsCompleted(loading, error) {
    return loading == false && error == null;
}

function CenteredSpinner() {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    );
}

export function sdRenderLoadingOrError(loading, error) {
    if (error) {
        return (<IconAlert variant='danger'>
            <p className="mb-0 text-center">An error occured making the request. Please try again later.</p>
        </IconAlert>);
    }

    if (loading) {
        return <><CenteredSpinner></CenteredSpinner></>
    }
}

export function sdFilterUsersByProjectAndAgents(users, projectId) {
    return users.filter(o => o.projects.some(p => p.id === projectId) && o.role != 'Customer');
}

export function sdShowToast(message, error) {
    let autoClose = error ? false : 1000;

    let options = {
        position: "top-right",
        theme: "colored",
        autoClose: autoClose,
    }
    if (error) {
        toast.error(message, options);
    } else {
        toast.success(message, options);
    }
}

export function sdUTCTimestampStrToLocalStr(timestamp) {
    const utcDateTime = dayjs.utc(timestamp);
    const ukDateTime = utcDateTime.tz('Europe/London');
    return ukDateTime.format('DD/MM/YYYY HH:mm')
}

export function sdTimeAgoFromUTCTimestamp(timestamp) {
    const localTime = dayjs.utc(timestamp).tz('Europe/London');
    return sdTimeAgo(localTime)
}

export function sdTimeAgo(dateInput) {
    const now = dayjs();
    const inputDate = dayjs(dateInput);

    if (!inputDate.isValid()) {
        return 'Invalid date';
    }

    return inputDate.from(now); // e.g., "5 seconds ago", "2 hours ago"
}

export function sdUTCTimestampToFriendlyDateAndTimeAgo(utcTimestamp) {
    return `${sdUTCTimestampStrToLocalStr(utcTimestamp)} (${sdTimeAgoFromUTCTimestamp(utcTimestamp)})`
}
export function sdDownloadAttachment(attachmentId) {
    sdGenerateAttachmentDownloadURL(attachmentId).then(res => {
        var url = res.data;
        console.log("DOWNLOAD URL = ", url);
        window.open(url);
    });

}

export const sdGetAttachmentIcon = ext => {
    const icon = ['far'];
    if (ext.includes('jpg') || ext.includes('png')) {
        icon.push('file-image');
    }
    if (ext.includes('.mp4')) {
        icon.push('file-video');
    }
    if (ext.includes('.wav')) {
        icon.push('file-audio');
    }
    if (ext.includes('zip')) {
        icon.push('file-archive');
    }
    if (ext.includes('pdf')) {
        icon.push('file-pdf');
    }
    if (
        ext.includes('html') ||
        ext.includes('css') ||
        ext.includes('json') ||
        ext.includes('javascript')
    ) {
        icon.push('file-code');
    }
    if (icon.length === 1) {
        icon.push('file');
    }
    return icon;
};

export function sdFormatBytes(bytes, decimals = 1) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    const value = bytes / Math.pow(k, i);
    return `${parseFloat(value.toFixed(decimals))} ${sizes[i]}`;
}

export function sdTruncateString(str, maxLength) {
    if (str.length <= maxLength) return str;
    return str.slice(0, maxLength - 3) + '...';
}

const SD_SELECTED_PROJECT_ID_KEY = "sdSelectedProjectId";

export function sdSetSelectedProjectId(projectId) {
    localStorage.setItem(SD_SELECTED_PROJECT_ID_KEY, projectId);
}

export function sdGetSelectedProjectId() {
    let val = localStorage.getItem(SD_SELECTED_PROJECT_ID_KEY);
    if (val === null) {
        // TODO get default project id for user
        sdSetSelectedProjectId(1);
        return 1;
    } else {
        return val;
    }
}

function isUpperCase(char) {
    const code = char.charCodeAt(0);
    return code >= 65 && code <= 90;
}


export function sdCamelCaseToFriendlyText(input) {
    let res = ''
    for (let i = 0; i < input.length; i++) {
        let currentChar = input[i];
        if (i == 0) {
            res += currentChar.toUpperCase();
        }
        else if (isUpperCase(currentChar)) {
            res += ' '
            res += currentChar;
        } else {
            res += currentChar;
        }
    }
    return res;
}

export function sdInitialsToColour(input) {
    // Simple hash function
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
        hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Generate RGB components with high brightness
    const r = (hash >> 16) & 0xFF;
    const g = (hash >> 8) & 0xFF;
    const b = hash & 0xFF;

    // Boost brightness by mixing with white
    const mix = 180; // Minimum brightness
    const brightR = Math.floor((r + mix) / 2);
    const brightG = Math.floor((g + mix) / 2);
    const brightB = Math.floor((b + mix) / 2);

    return `rgb(${brightR}, ${brightG}, ${brightB})`;
}

export function sdTextToInitials(input) {
    let res = input;
    res = res.split('@')[0];
    res = res.replace('.', ' ');
    res = res.replace('_', ' ');
    res = res.replace('-', ' ');
    res = res.split(/\s+/)              // Split by whitespace
        .map(word => word[0])      // Take the first character of each word
        .join(' ');                 // Join them into a single string
    res = res.toUpperCase();
    return res;
}

export function sdHtmlToPlainText(htmlString) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Replace <br> and <p> with newline characters
    const withBreaks = htmlString
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<\/div>/gi, "\n");

    tempDiv.innerHTML = withBreaks;
    return tempDiv.textContent || tempDiv.innerText || "";

}

